import isNumber from "lodash/fp/isNumber";
import concat from "lodash/fp/concat";
import reportBottomSheet from "./reportBottomSheet/reportBottomSheet.html";
import reportBottomSheetCtrl from "./reportBottomSheet/reportBottomSheet.controller";

class Controller {
  constructor($mdBottomSheet, $injector, $mdSidenav) {
    "ngInject";

    this.$mdSidenav = $mdSidenav;
    this.$mdBottomSheet = $mdBottomSheet;
    this.User = $injector.get("User");
    this.Events = $injector.get("Events");
    this.Ticket = $injector.get("Ticket");
    this.Messages = $injector.get("Messages");
    this.SlackFormatter = $injector.get("SlackFormatter");
    this.CollectUserData = $injector.get("CollectUserData");
    this.Authentication = $injector.get("Authentication");
    this.AuditorHandler = $injector.get("AuditorHandler");
    this.activities = [];
  }

  $onInit() {
    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;

    this.isOpen = false;
    this.selectedMode = "md-fling";
    this.selectedDirection = "up";
  }

  openReport() {
    const open = this.$mdBottomSheet.show({
      template: reportBottomSheet,
      controller: reportBottomSheetCtrl,
      controllerAs: "$ctrl",
    });

    open.then(
      (obj) => {
        const owner = this.Authentication.getValue("owner");

        this.User.get(owner).$promise.then((response) => {
          const userData = this.CollectUserData.collect();
          const data = Object.assign(userData, { user: response.name });
          const slackData = this.SlackFormatter.format(
            obj.title,
            obj.comment,
            data
          );

          this.Ticket.post(slackData).$promise.then(() => {
            this.Events.emit(
              this.showNotificationEvent,
              this.Messages.ticketCreatedMessage()
            );
          });
        });
      },
      () => {}
    );
  }

  getActivities(params) {
    params = Object.assign({}, this.activityParams, params);
    this.AuditorHandler.list(params).then((response) => {
      this.activities = concat(response.hits, this.activities);
      this.hasLoadmore = response.total > this.activities;
    });
  }

  showActivities() {
    this.$mdSidenav("activities-sidenav").open();
    this.getActivities({ page: 1, limit: 100 });
  }

  loadMoreActivities() {
    const previousPage = this.activityParams.page;
    const page = isNumber(previousPage) ? previousPage + 1 : 2;

    this.getActivities({ page, limit: 100 });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/mainFooter/mainFooter.controller.js